import React from 'react';
import { Award, Merge } from 'lucide-react';

const TeeterTotterChart = ({ portfolio, benchmark, fieldName }) => {
    const higherIsBetter = !['avg_dd', 'max_dd', 'avg_dd_duration'].includes(fieldName);
    const maxAngle = 30;
    const ratio = (portfolio - benchmark) / Math.max(Math.abs(portfolio), Math.abs(benchmark));
    const angle = Math.min(Math.max(ratio * maxAngle, -maxAngle), maxAngle);

    // Softer color palette
    const greenStart = '#34d399';  // Softer green
    const greenEnd = '#059669';    // Darker green
    const redStart = '#f87171';    // Softer red
    const redEnd = '#dc2626';      // Darker red

    const portfolioColor = higherIsBetter ?
        (portfolio >= benchmark ? `url(#greenGradient)` : `url(#redGradient)`) :
        (portfolio <= benchmark ? `url(#greenGradient)` : `url(#redGradient)`);
    const benchmarkColor = higherIsBetter ?
        (benchmark >= portfolio ? `url(#greenGradient)` : `url(#redGradient)`) :
        (benchmark <= portfolio ? `url(#greenGradient)` : `url(#redGradient)`);

    return (
        <svg width="120" height="60" viewBox="0 0 120 60">
            {/* Gradients definitions */}
            <defs>
                <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor={greenStart} />
                    <stop offset="100%" stopColor={greenEnd} />
                </linearGradient>
                <linearGradient id="redGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor={redStart} />
                    <stop offset="100%" stopColor={redEnd} />
                </linearGradient>
                <linearGradient id="legendGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor={higherIsBetter ? greenStart : redStart} />
                    <stop offset="100%" stopColor={higherIsBetter ? redStart : greenStart} />
                </linearGradient>
            </defs>

            {/* Legend bar at top */}
            <rect x="45" y="2" width="30" height="2" fill="url(#legendGradient)" />

            {/* Vertical axis line */}
            <line x1="60" y1="8" x2="60" y2="52" stroke="#94A3B8" strokeWidth="1.5" />

            {/* Top rotation icon */}
            <g transform="translate(52, 6)">
                <Award size={16} color="#3F3F46" fill={'#D4D4D8'} />
            </g>

            {/* Center tick mark */}
            <line x1="57" y1="30" x2="63" y2="30" stroke="#8c8c8c" strokeWidth="1" />

            {/* Rotating beam */}
            <g transform={`rotate(${angle}, 60, 30)`}>
                <line x1="20" y1="30" x2="100" y2="30" stroke="#94A3B8" strokeWidth="2" />

                {/* Portfolio marker (left) */}
                <g transform="translate(30, 30)">
                    <circle r="4" fill={portfolioColor} />
                    <text y="-8" textAnchor="middle" fill={portfolioColor} fontSize="10">
                        P
                    </text>
                </g>

                {/* Benchmark marker (right) */}
                <g transform="translate(90, 30)">
                    <circle r="4" fill={benchmarkColor} />
                    <text y="-8" textAnchor="middle" fill={benchmarkColor} fontSize="10">
                        B
                    </text>
                </g>
            </g>
        </svg>
    );
};

export default TeeterTotterChart;